import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"

export default class extends Controller {
  static targets = ["panel", "backdrop", "frame", "list"]
  static values = { frameId: String, initialUrl: String }

  connect() {
    this.handleListLoad = this.handleListLoad.bind(this)
    this.handleKeydown = this.handleKeydown.bind(this)

    if (this.hasListTarget) {
      this.listTarget.addEventListener("turbo:frame-load", this.handleListLoad)
    }

    document.addEventListener("keydown", this.handleKeydown)

    if (this.hasInitialUrlValue) {
      requestAnimationFrame(() => {
        this.openWithUrl(this.initialUrlValue)
      })
    }
  }

  disconnect() {
    if (this.hasListTarget) {
      this.listTarget.removeEventListener("turbo:frame-load", this.handleListLoad)
    }

    document.removeEventListener("keydown", this.handleKeydown)
  }

  open(event) {
    event.preventDefault()
    const url = event.currentTarget.dataset.sidePanelUrlValue || event.currentTarget.href
    if (!url) return

    this.openWithUrl(url)
  }

  close(event) {
    if (event) event.preventDefault()
    this.hidePanel()
  }

  handleListLoad() {
    this.hidePanel()
  }

  handleKeydown(event) {
    if (event.key === "Escape") {
      this.hidePanel()
    }
  }

  openWithUrl(url) {
    if (!url) return

    this.showPanel()
    Turbo.visit(url, { frame: this.frameIdValue })
  }

  showPanel() {
    if (this.hasBackdropTarget) {
      this.backdropTarget.classList.remove("hidden", "opacity-0", "pointer-events-none")
      requestAnimationFrame(() => this.backdropTarget.classList.add("opacity-100"))
    }

    if (this.hasPanelTarget) {
      this.panelTarget.classList.remove("hidden")
      requestAnimationFrame(() => this.panelTarget.classList.remove("translate-x-full"))
    }

    document.body.classList.add("overflow-hidden")
  }

  hidePanel() {
    if (this.hasBackdropTarget) {
      this.backdropTarget.classList.remove("opacity-100")
      this.backdropTarget.classList.add("opacity-0", "pointer-events-none")
      setTimeout(() => this.backdropTarget.classList.add("hidden"), 200)
    }

    if (this.hasPanelTarget) {
      this.panelTarget.classList.add("translate-x-full")
      setTimeout(() => this.panelTarget.classList.add("hidden"), 300)
    }

    document.body.classList.remove("overflow-hidden")
  }
}
